import { useEffect, useRef } from 'react';
import { SidebarType } from '../utils/SidebarStateManager';
import { useSidebarState } from './useSidebarState';
import { sidebarStateManager } from '../utils/SidebarStateManager';

/**
 * Hook that runs an effect when a specific sidebar transitions from closed to open
 * @param sidebarType The type of sidebar to watch
 * @param effect The effect to run when the sidebar opens
 */
export function useSidebarOpenEffect(
  sidebarType: SidebarType,
  effect: () => void
): void {
  const { activeSidebar } = useSidebarState(sidebarStateManager);
  const previousActiveSidebar = useRef<SidebarType | null>(null);

  useEffect(() => {
    const isNowOpen = activeSidebar === sidebarType;
    const wasOpen = previousActiveSidebar.current === sidebarType;

    // Detect transition from closed to open
    if (isNowOpen && !wasOpen) {
      effect();
    }

    // Update the previous state for next render
    previousActiveSidebar.current = activeSidebar;
  }, [activeSidebar, sidebarType, effect]);
}